import React, { ReactNode } from 'react';
import { notification } from 'antd';

import { ToastWarningIcon } from '@src/components/common/icons/ToastWarningIcon';

interface UseToast {
	open: (text: string, duration?: number) => void;
	openWarning: (text: string, duration?: number) => void;
}

const renderMessage = (text: string, icon?: ReactNode): ReactNode => (
	icon ?
		(
			<span style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
				{icon}
				{text}
			</span>
		) :
		text
);

const useToast = (): UseToast => {
	const open = (text: string, duration = 3) => {
		notification.open({
			placement: 'bottomRight',
			message: text,
			closeIcon: false,
			className: 'pwa-toast',
			bottom: 80,
			duration,
		});
	};

	const openWarning = (text: string, duration = 3) => {
		notification.open({
			placement: 'bottomRight',
			message: renderMessage(text, <ToastWarningIcon />),
			closeIcon: false,
			className: 'pwa-toast',
			bottom: 80,
			duration,
		});
	};

	return { open, openWarning };
};

export default useToast;
